module.exports = __webpack_public_path__ + "img/59.2b93001d.png";